// extracted by mini-css-extract-plugin
export var title = "Slideshow-module--title--I+s32";
export var titleHeader = "Slideshow-module--titleHeader--1BXPW";
export var slideshow = "Slideshow-module--slideshow--LT+dC";
export var slideshowimage2 = "Slideshow-module--slideshowimage2--tiQNj";
export var slider = "Slideshow-module--slider--YVaA1";
export var rightarrow = "Slideshow-module--rightarrow--d5ILg";
export var leftarrow = "Slideshow-module--leftarrow--CNmaG";
export var slide = "Slideshow-module--slide--CPFN+";
export var slideactive = "Slideshow-module--slideactive--hMxOb";
export var transitionImage = "Slideshow-module--transitionImage--4fPV2";
export var fadeIn = "Slideshow-module--fadeIn--ufwtN";
export var fadeOut = "Slideshow-module--fadeOut--+n1LO";